/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';

const DATE_TODAY = moment().format('YYYY-MM-DD');

const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const MOCK = {
  user: {
    current: {
      name: 'ณัฐพนธ์ เชาวนศิลป',
      firstName: 'ณัฐพนธ์',
      lastName: 'เชาวนศิลป',
      
      id: '011023',
      code: '08594111',
      zone: 'NE',

      email: 'someone@example.com',
      phone: '08594333211',
    
      username: 'xxxxx',
      imgSrc: 'http://placekitten.com/128/128',
      
      stat: {
        pendingOrder: {
          count: 54,
          total: 596800.50,
        },
        unpaid: {
          count: 99,
          total: 30004459,
        },
        backOrder: {
          count: 10,
          total: 600780.5,
        },
        awaitShipment: {
          count: 34,
          total: 7567000,
        },
      },

      performance: {
        today: {
          sales: 20000.59,
          commissions: 3167.0,
        },
        thisMonth: {
          sales: 45000,
          goal: 100000,
        },
      },
    },

    // Dashboard
    pendingApprovalList: [
      {
        id: 1,
        date: DATE_TODAY,
        entryNo: 'AB63111305',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
      },
      {
        id: 2,
        date: DATE_TODAY,
        entryNo: 'AB63111219',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 56170.00,
      },
      {
        id: 3,
        date: DATE_YESTERDAY,
        entryNo: 'AB63111205',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 40910.00,
      },
      {
        id: 4,
        date: DATE_YESTERDAY,
        entryNo: 'AB63111198',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 32100.00,
      },
      {
        id: 5,
        date: DATE_3_DAYS_AGO,
        entryNo: 'AB63111197',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 20490.00,
      },
      {
        id: 6,
        date: DATE_3_DAYS_AGO,
        entryNo: 'AB63111195',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 24790.00,
      },
      {
        id: 7,
        date: DATE_LASTWEEK,
        entryNo: 'AB63111193',
        customerZone: 'NE',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 17890.00,
      },
    ],

  },
};

const user = {
  async current() {
    return await helper.call('admin.user.current', {
      success: true,
      data: MOCK.user.current,
    }, async () => await axios(helper.path('admin/user/current')));
  },

  // Dashboard
  async pendingApprovalList() {
    return await helper.call('admin.user.pendingApprovalList', {
      success: true,
      data: MOCK.user.pendingApprovalList,
    }, async () => await axios(helper.path('admin/user/pending-approval-list')));
  },
};

export default user;
